import { useState, useCallback } from 'react';
import { getCheckoutUrl, validateCartBeforeCheckout } from '../lib/store/checkout';

interface UseCheckoutReturn {
    goToCheckout: () => Promise<void>;
    isLoading: boolean;
    error: string | null;
}

export const useCheckout = (): UseCheckoutReturn => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const goToCheckout = useCallback(async () => {
        setIsLoading(true);
        setError(null);

        try {
            const validation = await validateCartBeforeCheckout();

            if (!validation.valid) {
                setError(validation.message || 'Nie można przejść do kasy');
                setIsLoading(false);
                return;
            }

            const checkoutUrl = getCheckoutUrl();
            window.location.href = checkoutUrl;
        } catch (err) {
            console.error('❌ Błąd przejścia do kasy:', err);
            setError(err instanceof Error ? err.message : 'Wystąpił nieoczekiwany błąd podczas przejścia do kasy');
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {
        goToCheckout,
        isLoading,
        error,
    };
};
